import { sentenceOrPascalToCamel } from "../string/stringCase";

export const getWorkflowStageKey = (value: string | null | undefined): string =>
  value ? sentenceOrPascalToCamel(value.replace(/[_-]+/g, " ").trim()) : "";
